import service from "@/store/services/subscriptions-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  subscription: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, subscription) => {
    state.subscription = subscription;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((subscription) => {
      commit("SET_RESOURCE", subscription);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((subscription) => {
      commit("SET_RESOURCE", subscription);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((subscription) => {
      commit("SET_RESOURCE", subscription);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  renew({ commit, dispatch }, params) {
    return service.renew(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  subscription: (state) => state.subscription,
  url: (state) => state.url,
};

const subscriptions = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default subscriptions;
